<script lang="ts">
    import { location } from "../store"
    import { apiBaseURL, baseURL } from "../config"
    export let data: Navigation
    export let menuclass: string = null
    export let level: number
    export let depth: number = 1
    export let navopen: boolean

    let menu_open = "none"

    const triggerMenu = (which: string) => {
        menu_open = which ?? "none"
    }
</script>

<ul class="{menuclass ? menuclass : ''}">
    {#each data?.elements || [] as item, idx}
        <li class:haschildren="{!!item.elements?.length}" class:active="{menu_open == 'menu_' + idx}">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <a
                target="{item.newtab && '_blank'}"
                href="{!item.clickable ? (item.link ? item.link : item.path) : null}"
                class:active="{item.elements
                    .map((element) => element.link)
                    .flat()
                    .includes($location.path) ||
                    item.elements
                        .map((element) => element.path)
                        .flat()
                        .includes($location.path) ||
                    $location.path.includes(item.path) ||
                    $location.path.includes(item.link) ||
                    $location.path == item.path ||
                    $location.path == item.link}"
                on:click="{() => {
                    navopen = false
                }}"
            >
                {#if item.icon}
                    <span class="icon"
                        ><img
                            src="{!item.icon?.src.startsWith('data:')
                                ? apiBaseURL + 'navigation/' + data.id + '/' + item.icon?.src
                                : item.icon?.src}"
                            alt="{item.name}"
                        /></span
                    >
                {/if}

                {#if data.tree != 2}<span class="text">{item.name}</span>{/if}
            </a>
            {#if data.tree != 2}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <span class="trigger-submenu" on:click="{() => triggerMenu('menu_' + idx)}"
                    ><img src="/assets/icons/chevron-down.svg" alt="" /></span
                >
            {/if}

            {#if item.elements?.length && level < depth}
                <svelte:self
                    data="{item}"
                    menuclass="submenu"
                    level="{level + 1}"
                    depth="{depth}"
                    bind:navopen="{navopen}"
                />
            {/if}
        </li>
    {/each}
</ul>
